import { useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { downloadDismantleScheduleKpi } from "../../api/schedules";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import AlertBox from "../AlertBox";

function getDefaultFilter() {
  return {
    status: "",
    project_id: "",
    date_from: moment().subtract(3, "months").format("YYYY-MM-DD"),
    date_until: moment().format("YYYY-MM-DD"),
  };
}

export default function ModalDownloadDismantleKpi({ show, onClose, onSuccess }) {
  const [formFilter, setFormFilter] = useState(getDefaultFilter);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const { projects } = useGroupListHooks();

  const handleClose = () => {
    setFormFilter(getDefaultFilter());
    setAlert({ show: false, message: "", type: "" });
    onClose();
  };

  const downloadFile = async () => {
    setLoading(true);
    setAlert({ show: false, message: "", type: "" });

    try {
      const response = await downloadDismantleScheduleKpi({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data KPI Dismantle.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      onSuccess("Berhasil mengunduh Data KPI Dismantle.xlsx");
      handleClose();
    } catch (error) {
      let message = "Something Error Happened";

      try {
        const responseData = error.response?.data;
        const errorData =
          responseData instanceof Blob ? JSON.parse(await responseData.text()) : responseData;
        message = errorData?.message || message;
      } catch {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download KPI Dismantle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <div className="form-group">
          <label htmlFor="download-dismantle-kpi-status">Status</label>
          <select
            id="download-dismantle-kpi-status"
            className="form-control"
            value={formFilter.status}
            onChange={(event) => setFormFilter({ ...formFilter, status: event.target.value })}
            disabled={loading}
          >
            <option value="">SEMUA</option>
            <option value="WAITING-NOC">WAITING NOC</option>
            <option value="NOC-DONE">NOC DONE</option>
            <option value="DONE">DONE</option>
            <option value="CANCELED">CANCELED</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="download-dismantle-kpi-project">Project/Site</label>
          <select
            id="download-dismantle-kpi-project"
            className="form-control"
            value={formFilter.project_id}
            onChange={(event) => setFormFilter({ ...formFilter, project_id: event.target.value })}
            disabled={loading}
          >
            <option value="">SEMUA</option>
            {projects.map((project) => (
              <option value={project.id} key={project.id}>
                {project.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="download-dismantle-kpi-date-from">Tanggal Dari</label>
          <input
            type="date"
            id="download-dismantle-kpi-date-from"
            className="form-control"
            value={formFilter.date_from}
            onChange={(event) => setFormFilter({ ...formFilter, date_from: event.target.value })}
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label htmlFor="download-dismantle-kpi-date-until">Tanggal Sampai</label>
          <input
            type="date"
            id="download-dismantle-kpi-date-until"
            className="form-control"
            value={formFilter.date_until}
            onChange={(event) => setFormFilter({ ...formFilter, date_until: event.target.value })}
            disabled={loading}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
        <button type="button" className="btn btn-primary" onClick={downloadFile} disabled={loading}>
          <i className="fas fa-download" aria-hidden="true"></i>{" "}
          {loading ? "Harap Tunggu ..." : "Unduh Data"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
